import * as devisConf from '@/configuration/devisConf';

export default function miseAJourArticle(ligneCommande, tauxTvaParDefaut = null) {
  ligneCommande.typeRemise = devisConf.POURCENTAGE;
  ligneCommande.remise = 0;
  ligneCommande.tauxTva = tauxTvaParDefaut || 20;
  ligneCommande.uniteVente = devisConf.UNITE;
  ligneCommande.type = devisConf.NORMAL;
  ligneCommande.prixUnitaire = 0;
  ligneCommande.quantite = 1;
}
